import React, { useEffect, useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../../../services/AuthContext";
import axiosInstance from "../../../services/axiosInstance";
import { logo } from "../../imagepath";

const Logout = () => {
  const { auth, setAuth } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState("Oturumunuz sonlandırılıyor, lütfen bekleyin...");

  useEffect(() => {
    // URL'deki parametreleri kontrol et
    const queryParams = new URLSearchParams(location.search);
    const reason = queryParams.get("reason");
    const customMessage = queryParams.get("message");

    if (reason === "401") {
      setMessage(customMessage || "Oturum süreniz doldu veya yetkisiz erişim sağladınız. Giriş sayfasına yönlendiriliyorsunuz...");
    }

    const checkTokenAndLogout = async () => {
      try {
        const token = auth?.token || (localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")).token : null);
        if (token) {
          await axiosInstance.get("instutationactivetoken/TokenExpire", {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
        }
      } catch (error) {
        console.error("Logout hatası:", error);
      }

      setAuth({
        token: "",
        id: "",
        title: "",
        name: "",
        surname: "",
        email: "",
        telephone: "",
        address: "",
        regdate: "",
        tc: "",
        regstatus: "",
        mobileuser: "",
        updatedate: "",
      });

      localStorage.removeItem('auth');
      localStorage.removeItem('token');
      localStorage.removeItem('user_module_permissions');

      // Kullanıcının mesajı okuyabilmesi için biraz bekle ve yönlendir
      setTimeout(() => {
        navigate("/login");
      }, 2500);
    };

    checkTokenAndLogout();
  }, [setAuth, navigate, location.search, auth?.token]);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <div
        className="text-center shadow-sm bg-white rounded-4"
        style={{ maxWidth: "600px", padding: "4rem 3rem", borderTop: "5px solid #14A077" }}
      >
        <div className="mb-4">
          <img src={logo} alt="Logo" style={{ height: "45px", width: "auto" }} />
        </div>

        <div className="spinner-border mb-4" role="status" style={{ color: "#14A077", width: "3rem", height: "3rem", borderWidth: "0.2rem" }}>
          <span className="visually-hidden">Yükleniyor...</span>
        </div>

        <p className="text-muted m-0" style={{ fontSize: "1.15rem", lineHeight: "1.6" }}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default Logout;
